// extracted by mini-css-extract-plugin
module.exports = {"overlay":"SidePanel-module_overlay_da0f1","backdrop":"SidePanel-module_backdrop_dd6d0"};